import { SlideOut } from '@interstate/components/SlideOut';
import styled from 'styled-components';

export const ModalAuditLogContainer = styled(SlideOut)`
    .ids-slideout-close-button {
        cursor: pointer;
    }
    .ant-table .ant-table-container .ant-table-content table tbody.ant-table-tbody .ant-table-cell {
        vertical-align: top;
    }
`;
